// Entity Resolution API
import { apiClient } from './client'

/** Shared shape of an entity-resolution background job (recalculate / find-duplicates). */
export interface EntityResolutionJob {
  job_id: string
  case_id: string
  status: 'running' | 'completed' | 'failed'
  error: string | null
  started_at: string
  updated_at: string
  finished_at: string | null
}

export interface RecalculateJob extends EntityResolutionJob {
  result: {
    deleted: number
    groups_created: number
    members_attached: number
  } | null
}

export const entityResolutionApi = {
  recalculate: (caseId: string) =>
    apiClient.post<RecalculateJob>(`/cases/${caseId}/entity-resolution/recalculate`),

  getRecalculateStatus: (caseId: string, jobId?: string) =>
    apiClient.get<RecalculateJob>(`/cases/${caseId}/entity-resolution/recalculate/status`, {
      params: jobId ? { job_id: jobId } : undefined,
    }),
}
